<template>
  <import-tab>
    <template v-slot:form>
      <upload-apartments-users @uploaded="onUpload" />
      <apartments-users-import-popup
        :title="popupTitle"
        :isOpen="popupOpen"
        :info="popupData"
        @openChanged="popupOpen=$event"
      />
    </template>


  </import-tab>
</template>

<script>
import ApartmentsUsersImportPopup from "../ApartmentsUsersImportPopup";
import UploadApartmentsUsers      from "../UploadApartmentsUsers";
import ImportTab                  from "./ImportTab";

export default {
  name:       "ImportApartmentUsers",
  components: {
    ApartmentsUsersImportPopup,
    UploadApartmentsUsers,
    ImportTab,
  },
  props:      ['selectedHouseId'],
  data() {
    return {
      history: null,

      popupTitle: null,
      popupOpen:  null,
      popupData:  {},
    };
  },
  methods:    {
    onUpload( $event ) {
      this.popupTitle = 'Импорт пользователей завершен';
      this.popupOpen = true;
      this.popupData = $event.info;
      this.loadHistory();
    },
  },
};
</script>

<style scoped>

</style>
